module.exports = __webpack_public_path__ + "assets/img/gd3.a967bce0.jpg";